import { confirm, IconButton, mergeStyleSets, useTheme } from "@bps/fluent-ui";
import { dangerButtonStyles } from "@components/buttons/DangerButton";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { JobsConfigurationJob } from "./dtos";

interface JobDeleteButtonProps {
  job: JobsConfigurationJob;
  onDeleteJob: (job: JobsConfigurationJob) => void;
}

export const JobDeleteButton: React.FC<JobDeleteButtonProps> = ({
  job,
  onDeleteJob
}) => {
  const theme = useTheme();
  const { data: hasDeployPermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementDeploy
  );

  return (
    <IconButton
      onClick={async e => {
        e.stopPropagation();
        if (await confirmDeleteJob()) onDeleteJob(job);
      }}
      styles={mergeStyleSets(dangerButtonStyles(theme), {
        root: {
          background: "transparent"
        }
      })}
      iconProps={{
        iconName: "Cancel"
      }}
      disabled={!hasDeployPermission}
      title={!hasDeployPermission ? NO_ACTION_PERMISSION : undefined}
    />
  );
};

const confirmDeleteJob = async () => {
  const isConfirmed = await confirm({
    confirmButtonProps: {
      text: "Delete"
    },
    cancelButtonProps: {
      text: "Cancel"
    },
    dialogContentProps: {
      title: "Delete this job?",
      subText: "Are you sure you want to delete this job?"
    }
  });
  return isConfirmed;
};
